function isOnScreen(elem) {
  // if the element doesn't exist, abort
  if (elem.length == 0) {
    return;
  }
  var $window = jQuery(window);
  var viewport_top = $window.scrollTop();
  var viewport_height = $window.height();
  var viewport_bottom = viewport_top + viewport_height;
  var $elem = jQuery(elem);
  var top = $elem.offset().top;
  var height = $elem.height();
  var bottom = top + height;

  return (
    (top >= viewport_top && top < viewport_bottom) ||
    (bottom > viewport_top && bottom <= viewport_bottom) ||
    (height > viewport_height &&
      top <= viewport_top &&
      bottom >= viewport_bottom)
  );
}
var tooltipTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="tooltip"]')
);
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl);
});

$(document).ready(function () {
  $(document).on("click", ".js_cart_checkout1", function (e) {
    var cartNote = $(".cart_note").val();
    var finalNote = "note=" + cartNote;
    jQuery.post(window.Shopify.routes.root + "cart/update.js", finalNote);
    window.location = "/pages/suggestions";
  });
});
$(document).ready(function () {
  var page_url = window.location.href;
  // console.log(page_url);
});
$(document).ready(function () {
  // var startedFromIndexPage = false;
  // function StartSlideShowFirstImage() {
  //    startedFromIndexPage = true;
  //    $('a[data-lightbox]').first().trigger('click');
  //    $.fancybox.getInstance().SlideShow.toggle();
  // }
  // $('[data-lightbox]').fancybox({
  //   buttons: [
  //     "slideShow",
  //     "thumbs",
  //     "zoom",
  //     "fullScreen",
  //     "share",
  //     "close"
  //   ],
  //   loop: false,
  //   protect: true
  // });

  if (
    isOnScreen($(".non-sticky-atc-button").eq(0)) ||
    isOnScreen($(".non-sticky-atc-button").eq(1)) ||
    isOnScreen($(".non-sticky-atc-button").eq(2)) ||
    isOnScreen($(".non-sticky-atc-button").eq(3)) ||
    isOnScreen($(".non-sticky-atc-button").eq(4)) ||
    isOnScreen($(".non-sticky-atc-button").eq(5)) ||
    isOnScreen($(".non-sticky-atc-button").eq(6)) ||
    isOnScreen($(".non-sticky-atc-button").eq(7)) ||
    isOnScreen($(".non-sticky-atc-button").eq(8)) ||
    isOnScreen($("#footer"))
  ) {
    $(".sticky-atc-button").fadeOut(100);
  } else {
    $(".sticky-atc-button").fadeIn(100);
  }

  $(window).on("scroll", function () {
    if (
      isOnScreen($(".non-sticky-atc-button").eq(0)) ||
      isOnScreen($(".non-sticky-atc-button").eq(1)) ||
      isOnScreen($(".non-sticky-atc-button").eq(2)) ||
      isOnScreen($(".non-sticky-atc-button").eq(3)) ||
      isOnScreen($(".non-sticky-atc-button").eq(4)) ||
      isOnScreen($(".non-sticky-atc-button").eq(5)) ||
      isOnScreen($(".non-sticky-atc-button").eq(6)) ||
      isOnScreen($(".non-sticky-atc-button").eq(7)) ||
      isOnScreen($(".non-sticky-atc-button").eq(8)) ||
      isOnScreen($(".non-sticky-atc-button").eq(9)) ||
      isOnScreen($("#footer"))
    ) {
      $(".sticky-atc-button").fadeOut(10);
    } else {
      $(".sticky-atc-button").fadeIn(10);
    }
  });
  $(".mobile-meu-icon").click(function () {
    $("body").toggleClass("sidebar-menu");
  });
  $(".btn-close-sidebar").click(function () {
    $("body").removeClass("sidebar-menu");
  });
  $(".filter-mobile").click(function () {
    $("body").toggleClass("shop-sidebar");
  });
  $(".product-sidebar .sidebar-list .item ul li").click(function () {
    $("body").removeClass("shop-sidebar");
  });
  $(document).mouseup(function (e) {
    var container = $(".navbar.header-menu");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $("body").removeClass("sidebar-menu");
    }
    var container2 = $(".product-sidebar");
    if (!container2.is(e.target) && container2.has(e.target).length === 0) {
      $("body").removeClass(".shop-sidebar");
    }
  });

  $(".btnsearch").click(function (e) {
    $(".header-search").toggleClass("show");
    e.stopPropagation();
  });
  if ($(".menu-list ").length > 0) {
    $(".menu-list > li .icon-down-open").click(function () {
      $(this).closest("li").toggleClass(" active ");
      $(this).closest("li").siblings().removeClass(" active ");
      $(".submneu").stop().slideUp();
      $(".active > .submneu").stop().slideDown();
      return false;
    });
  }
  if ($(".testimonial-slider").length > 0) {
    $(".testimonial-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      lazyLoad: "progressive",
      arrows: true,
      dots: true,
      prevArrow:
        '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  if ($(".testimonial-slider-pdp").length > 0) {
    $(".testimonial-slider-pdp").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      lazyLoad: "progressive",
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  if ($(".single-product-slider").length > 0) {
    $(".single-product-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "progressive",
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
    });
  }
  if ($(".slider-for").length > 0) {
    $(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      arrows: true,
      infinite: true,
      draggable: false,
      // adaptiveHeight: true,
      asNavFor: ".slider-nav",
      prevArrow:
        '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
    });
  }
  if ($(".slider-nav").length > 0) {
    var test = $(".slider-nav .item").length;
  }
  if (test <= 5) {
    $(".slider-nav").addClass("show-five-item");
  } else {
    $(".slider-nav").removeClass("show-five-item");
  }
  if ($(".slider-nav").length > 0) {
    $(".slider-nav").slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: ".slider-for",
      arrows: false,
      dots: false,
      infinite: true,
      focusOnSelect: true,
    });
  }

  var showChar = 150; // How many characters are shown by default
  var moretext = "Read more...";
  var lesstext = "Read less";

  //Cut content based on showChar length
  if ($(".short-description").length) {
    $(".short-description .details").each(function () {
      var content = $(this).html();
      console.log(content);

      if (content.length > showChar) {
        var contentExcert = content.substr(0, showChar);
        var contentRest = content.substr(showChar, content.length - showChar);
        var html =
          contentExcert +
          '<span class="toggle-text-content"><span>' +
          contentRest +
          '</span><a href="javascript:;" class="toggle-text-link">' +
          moretext +
          "</a></span>";

        $(this).html(html);
      }
    });
  }
  //Toggle content when click on read more link
  $(".toggle-text-link").click(function () {
    if ($(this).hasClass("less")) {
      $(this).removeClass("less");
      $(this).html(moretext);
    } else {
      $(this).addClass("less");
      $(this).html(lesstext);
    }
    $(this).parent().prev().toggle();
    $(this).prev().toggle();
    return false;
  });

  if ($(".quantity").length > 0) {
    $(".quantity").on("click", ".plus", function (e) {
      let $input = $(this).prev("input.qty");
      let val = parseInt($input.val());
      $input.val(val + 1).change();
    });

    $(".quantity").on("click", ".minus", function (e) {
      let $input = $(this).next("input.qty");
      var val = parseInt($input.val());
      if (val > 0) {
        $input.val(val - 1).change();
      }
    });
  }

  if ($(".quantity").length > 0) {
    $(".quantity").on("click", ".js_pdp_plus", function (e) {
      let $input = $(this).prev("input.qty");
      let val = parseInt($input.val());
      $input.val(val + 1).change();
    });

    $(".quantity").on("click", ".js_pdp_minus", function (e) {
      let $input = $(this).next("input.qty");
      var val = parseInt($input.val());
      if (val > 1) {
        $input.val(val - 1).change();
      }
    });
  }

  if ($(".team-slider").length > 0) {
    $(".team-slider").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      lazyLoad: "progressive",
      arrows: true,
      dots: false,
      prevArrow:
        '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
  if ($(".youtube-video-slider").length > 0) {
    $(".youtube-video-slider").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      lazyLoad: "progressive",
      arrows: true,
      dots: true,
      prevArrow:
        '<button type="button" class="prev-arrow"><span class="icon-left-open"></span></button>',
      nextArrow:
        '<button type="button" class="next-arrow"><span class="icon-right-open"></span></button>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
});
if ($(".product-box .details") != null) {
  $.fn.equalHeights = function () {
    var max_height = 0;
    $(this).each(function () {
      max_height = Math.max($(this).height(), max_height);
    });
    $(this).each(function () {
      $(this).height(max_height);
    });
  };

  $(document).ready(function () {
    $(".product-box .details").equalHeights();
  });

  $(window).on("load resize", function (e) {
    $(".product-box .details").equalHeights();
  });
}
if ($(".blog-box .content h4") != null) {
  $(window).on("load resize", function (e) {
    if ($(".blog-box .content h4 ").length > 0) {
      $(".blog-box .content h4").matchHeight({
        byRow: true,
      });
    }
    if ($(".pdp-box-list .content p ").length > 0) {
      $(".pdp-box-list .content p").matchHeight({
        byRow: true,
      });
    }
    if ($(".product-box-main .details h4 ").length > 0) {
      $(".product-box-main .details h4").matchHeight({
        byRow: true,
      });
    }
  });
}

$(window).on("load", function () {
  setTimeout(function () {
    $(".page-loader").fadeOut("fast");
  }, 100);
});

("use strict");

(function (document, window, index) {
  var inputs = document.querySelectorAll(".inputfile");
  Array.prototype.forEach.call(inputs, function (input) {
    var label = input.nextElementSibling,
      labelVal = label.innerHTML;

    input.addEventListener("change", function (e) {
      var fileName = "";
      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      else fileName = e.target.value.split("\\").pop();

      if (fileName) label.querySelector("span").innerHTML = fileName;
      else label.innerHTML = labelVal;
    });

    // Firefox bug fix
    input.addEventListener("focus", function () {
      input.classList.add("has-focus");
    });
    input.addEventListener("blur", function () {
      input.classList.remove("has-focus");
    });
  });
})(document, window, 0);

//SALES PAGE PRODUCT ATC JS START
$(document).ready(function () {
  $(document).on("click", ".single-product-atc", function (e) {
    e.preventDefault();
    var target = e.target;
    var data_id = $(this).attr("data-id");
    var quantity = 1;
    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      dataType: "JSON",
      data: { id: data_id, quantity: quantity },
      success: function () {
        window.location = "/cart";
      },
    });
  });
});
$("#redemDevPromo").on("click", function (event) {
  //disable the button event
  event.preventDefault();
  //write the url format
  var theUrl = "/checkout?discount=";
  //grab the discount code from the input
  var theDiscount = $("#devPromo").val();
  //full url to redirect to checkout with promo code
  var toRedirect = theUrl + theDiscount;
  //console.log(toRedirect);
  //redirect
  window.location.href = toRedirect;
});
$(".quantity .qty-button").click(function () {
  val = parseInt($(this).parent().find(".js_product_qty").val());

  if ($(this).hasClass("qtyminu")) {
    val = val - 1;
  }
  //  else if ($(this).hasClass('more')) {
  // 	val = val + 1;

  // }

  if (val < 1) {
    val = 1;
  }

  $(this).parent().find(".js_product_qty").val(val);
  $(this).parent().find(".js_product_qty").trigger("change");
});
$(document).on("change", "[name='updates[]']", function (e) {
  $("#cart_form").eq(0).submit();
});
$(".cart-popup .cartpopup-body").on(
  "click",
  ".cartpopup-item .remove",
  function (e) {
    var obj = $(this);
    e.preventDefault();
    e.stopPropagation();

    var productId = $(this).attr("data-variant");

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      dataType: "json",
      data: {
        quantity: 0,
        id: productId,
      },
      success: function (data) {
        $.ajax({
          type: "GET",
          dataType: "jsonp",
          url: "/cart.json",
          success: function (cart) {
            var item_count = cart["item_count"];
            var total_price = cart["total_price"] / 100;

            if (item_count > 0) {
              $(".cart-item-count span").text(item_count);

              // mini cart data
              $(".cart-popup").attr("id", "cartPopup");
              $(".cartpopup-total .price").text("£" + total_price.toFixed(2));

              // Remove item

              $(this).parents(".cartpopup-item").remove();
            }
          },
        });
      },
    });
  }
);

//SALES PAGE PRODUCT ATC JS END
const loadMore = document.getElementById("loadmore");
const hid = [...document.querySelectorAll(".item.hidden")];

hid.splice(0, 9).forEach((elem) => elem.classList.remove("hidden"));

if (loadMore !== null) {
  loadMore.addEventListener("click", function (e) {
    e.preventDefault();

    hid.splice(0, 6).forEach((elem) => elem.classList.remove("hidden"));

    if (hid.length == 0) {
      loadMore.classList.add("hidden");
    }
  });
}

//listen to the promo button click

// $(document).on('click', '.js_qtyminus', function (e) {
// 	//alert(123);
// 	exit;
// 	let parent = $(e.target).parents('.js-qty__wrapper').eq(0);
// 	let current_qty = $(parent).attr('data-quantity');
// 	let updated_qty = parseInt(current_qty) - 1;
// 	let current_item = {};
// 	if (updated_qty <= 0) {
// 		updated_qty = 0;
// 	}
// 	let key = $(parent).attr('data-key');
// 	current_item[key] = updated_qty;
// 	$.ajax({
// 		url: "/cart/update.js",
// 		data: { 'updates': current_item },
// 		method: "POST",
// 		dataType: "JSON",
// 		success: function (data) {
// 			refreshCart();

// 		}, error: function (error) {
// 			console.log(error)
// 		}
// 	});
// });

$(document).on("click", ".js_qtyminus", function (e) {
  let parent = $(e.target).parents(".js-qty__wrapper").eq(0);
  let current_qty = $(parent).attr("data-quantity");
  let updated_qty = parseInt(current_qty) - 1;
  // let current_item = {};
  if (updated_qty <= 0) {
    updated_qty = 0;
  }
  let key = $(parent).attr("data-key");
  let quantity = parseInt(current_qty) - 1;

  let current_item = {};
  current_item[key] = quantity;
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      updates: current_item,
    }),
  };
  let fetchRes = fetch("/cart/update.js", options);
  fetchRes
    .then((res) => res.json())
    .then((d) => {
      // window.location = "/cart";
    });
});

$(document).on("click", ".js_qtyplus", function (e) {
  e.preventDefault();

  let parent = $(e.target).parents(".js-qty__wrapper").eq(0);
  let current_qty = $(parent).attr("data-quantity");
  let updated_qty = parseInt(current_qty) + 1;
  let current_item = {};
  let key = $(parent).attr("data-key");

  current_item[key] = updated_qty;
  let options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      updates: current_item,
    }),
  };
  let fetchRes = fetch("/cart/update.js", options);
  fetchRes.then((res) => res.json()).then((d) => {});
});

function createTooltip() {
  setTimeout(function () {
    var mainWrapper = $(".js-single-dropdown");
    var tooltipWrapper = mainWrapper.find($(".selector-wrapper"));
    var tooltipIndex = tooltipWrapper.length;
    var label = tooltipWrapper.find("label");
    var optionTooltip = $(".js-option-tooltip");
    label.wrap("<div class='label-wrapper'></div>");

    var labelWrapepr = tooltipWrapper.find(".label-wrapper");

    labelWrapepr.append(
      "<div class='option-tooltip js-option-tooltip'><span class='option-tooltip__btn js-option-tooltip-btn'>i</span><div class='option-tooltip__modal js-option-tooltip-modal' data-tooltip=''><span class='option-tooltip__close-btn js-option-tooltip-close-btn'>x</span></div></div>"
    );

    let tooltipContent = $(".tooltip-content");

    labelWrapepr.each(function (index, element) {
      // let singleItem = $(tooltipContent).find('.tooltip-single');
      index = index + 1;
      $(element)
        .find(".js-option-tooltip-modal")
        .attr("data-tooltip", "tooltip-" + index);
      $(".tooltip-content .tooltip-item").each(function (sub, subElement) {
        sub = sub + 1;
        if (index == sub) {
          var currentText = $(this).html();
          $(element).find(".js-option-tooltip-modal").append(currentText);
        }
      });
    });

    $(".js-option-tooltip-btn").click(function () {
      $(".js-option-tooltip-modal").removeClass("active");
      $(this).siblings(".js-option-tooltip-modal").toggleClass("active");
    });

    $(".js-option-tooltip-close-btn").click(function () {
      $(this).parent(".js-option-tooltip-modal").removeClass("active");
    });
  }, 2000);
}

createTooltip();
